import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

import { impressionsConfig } from '../impressions';

export const mediaViewerImpressionsConfig = {
    ...impressionsConfig,
    name: 'kpi.twitter.mediaviewer.impressions',
    tooltip: null,
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
